import { render, staticRenderFns } from "./tendency.vue?vue&type=template&id=ac6b1024&"
import script from "./tendency.vue?vue&type=script&lang=js&"
export * from "./tendency.vue?vue&type=script&lang=js&"
import style0 from "./tendency.vue?vue&type=style&index=0&lang=less&scpoed=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports